export const LOGIN_PAGE_PATHNAME = "/login";
export const MAIN_PAGE_PATHNAME = "/main";

export const CHOOSE_ORGANIZATION_PATHNAME = "/login/choose-organization";
export const MINI_LK_PAGE_PATHNAME = "/login/mini-lk";
export const REDIRECT_ON_APP_STORE_PAGE_PATHNAME = "/login/app-store-redirect";
